export default __webpack_public_path__ + "static/media/DSC_9098-thumb.6d74ee0c.jpg";